import { render, staticRenderFns } from "./Legal.vue?vue&type=template&id=341d6378&scoped=true&"
import script from "./Legal.vue?vue&type=script&lang=js&"
export * from "./Legal.vue?vue&type=script&lang=js&"
import style0 from "./Legal.vue?vue&type=style&index=0&id=341d6378&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341d6378",
  null
  
)

export default component.exports